import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Accordion from '../../../components/common/Accordion';
import Button from '../../../components/common/Button';
import { hasOmniPIN } from '../../../modules/account/selectors';
import { HOME } from '../../../routes/paths';
import { restrictionsAgreed } from '../actions';
import { getWithdrawPage } from '../../../modules/content/selectors';
import backupContent from '../../../../resources/withdrawBackup.json';

export const Restrictions = ({ hasPIN, agreed, history, contentStackContent }) => {
  const openSetPINPage = () => {
    window.open(api_config.online_set_pin_url, '_blank');
    return false;
  };

  let content;
  if (contentStackContent) {
    content = contentStackContent;
  } else {
    content = backupContent;
  }

  return (
    <div className="withdraw-restrictions">
      <div className="withdraw-restrictions__container">
        <div className="withdraw-restrictions__header" dangerouslySetInnerHTML={{ __html: content.restrictions.title }} />
        <div className="withdraw-restrictions__section">
          <h2 className="withdraw-restrictions__section-header" dangerouslySetInnerHTML={{ __html: content.restrictions.header }} />
          <div className="withdraw-restrictions__section-paragraph">
            <span dangerouslySetInnerHTML={{ __html: content.restrictions.text }} />
            <Accordion
              headerText={content.learnMoreText}
              className="withdraw-restrictions__accordion"
            >
              <div className="withdraw-restrictions__accordion-content">
                <p className="withdraw-restrictions__section-info" dangerouslySetInnerHTML={{ __html: content.restrictions.moreText }} />
              </div>
            </Accordion>
          </div>
        </div>
        {!hasPIN && (
          <div className="withdraw-restrictions__section">
            <h2 className="withdraw-restrictions__section-header" dangerouslySetInnerHTML={{ __html: content.restrictions.pin.header }} />
            <p className="withdraw-restrictions__section-paragraph" dangerouslySetInnerHTML={{ __html: content.restrictions.pin.text }} />
          </div>
        )}
        <div className="withdraw-restrictions__buttons">
          {hasPIN ? (
            <Button className="withdraw-restrictions__button" onClick={agreed}>
              <span dangerouslySetInnerHTML={{ __html: content.restrictions.acceptButtonText }} />
            </Button>
          ) : (
            <Button className="withdraw-restrictions__button" onClick={openSetPINPage}>
              <span dangerouslySetInnerHTML={{ __html: content.restrictions.pin.buttonText }} />
            </Button>
          )}
          <Button
            className="withdraw-restrictions__button button--secondary"
            onClick={() => history.push(HOME)}
          >
            <span dangerouslySetInnerHTML={{ __html: content.restrictions.backButtonText }} />
          </Button>
        </div>
      </div>
    </div>
  );
};

Restrictions.propTypes = {
  hasPIN: PropTypes.bool,
  agreed: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  contentStackContent: PropTypes.object
};

const mapStateToProps = state => ({
  hasPIN: hasOmniPIN(state),
  contentStackContent: getWithdrawPage(state)
});

const mapDispatchToProps = {
  agreed: restrictionsAgreed
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Restrictions));
